import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class PanelPopup extends Vue {
	@Prop({ default: false })
	public isVisible;

	public isVisibleDelay: boolean = false;

	@Prop({ default: 0 })
	public x;

	@Prop({ default: 0 })
	public y;

	@Prop()
	public width;

	@Prop()
	public maxWidth;

	public click(e): void {
		e.preventDefault();
		e.stopPropagation();
	}

	@Watch('isVisible')
	public watchVisibility() {
		if (this.isVisible) {
			this.isVisibleDelay = true;
		} else {
			setTimeout(() => {
				this.isVisibleDelay = false;
			},200);
		}
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/PanelPopup/PanelPopup.ts